import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import React from 'react';
import { wdsThemeColors } from './wds-theme-colors';
export const ThemeAwareIcon = _ref => {
  let {
    children,
    color = wdsThemeColors.iconPrimary,
    ...boxProps
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    color: color
  }, boxProps), children);
};
//# sourceMappingURL=theme-aware-icon.js.map